import { useState } from "react";
import { Link, useNavigate, Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={redirect} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) { toast.success("Welcome back."); nav(redirect); }
    else setErr(r.error || "Login failed");
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="eyebrow mb-6">{t("login.eyebrow")}</div>
        <h1 className="font-headline text-5xl md:text-6xl leading-none">{t("login.title")}</h1>
        <p className="font-body text-[#3A3A3A] mt-6 max-w-md">
          {t("login.intro")}
        </p>
      </div>
      <div className="md:col-span-7">
        <form onSubmit={submit} className="border border-[#DCDCDC] p-8 md:p-10 max-w-lg" data-testid="login-form">
          <label className="block mb-5">
            <span className="font-ui text-[10px] tracking-[0.25em] uppercase text-[#6C6C6C] block mb-2">Email</span>
            <input required type="email" className="editorial-input" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="block mb-5">
            <span className="font-ui text-[10px] tracking-[0.25em] uppercase text-[#6C6C6C] block mb-2">Password</span>
            <input required type="password" className="editorial-input" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          {err && <div className="font-body text-sm text-[#111111] mb-4 border border-[#111111] px-3 py-2" data-testid="login-error">{err}</div>}
          <button disabled={busy} type="submit" className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
          <div className="mt-6 font-body text-sm text-[#3A3A3A]">
            No account? <Link to={`/signup${redirect !== "/dashboard" ? `?redirect=${redirect}` : ""}`} className="underline underline-offset-4">Get your library card</Link>.
          </div>
        </form>
      </div>
    </div>
  );
}
